import { Controller } from "@hotwired/stimulus"

// Hides a value behind dots until the user asks to see it.
//
//   <span data-controller="secret">
//     <span data-secret-target="mask">••••••••</span>
//     <span data-secret-target="value" hidden>s3cr3t</span>
//     <button data-action="secret#toggle" data-secret-target="button">…</button>
//   </span>
export default class extends Controller {
    static targets = ["mask", "value", "button"]
    static values = { shown: { type: Boolean, default: false } }

    toggle() {
        this.shownValue = !this.shownValue
    }

    // Stimulus calls this on every change of `shown`, including the initial one,
    // so the markup only has to be right for the hidden state.
    shownValueChanged() {
        this.maskTarget.hidden = this.shownValue
        this.valueTarget.hidden = !this.shownValue

        if (!this.hasButtonTarget) return

        const label = this.shownValue ? "Wert verbergen" : "Wert anzeigen"
        this.buttonTarget.setAttribute("aria-label", label)
        this.buttonTarget.setAttribute("title", label)
        this.buttonTarget.setAttribute("aria-pressed", String(this.shownValue))
    }
}
